




























































































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchRecepcion } from '../fetchRecepcion';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridReadyEvent, GridApi } from 'ag-grid-community';

@Component({
  components: {
    DatePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class EditarGeneral extends Vue {
  @Prop({ default: false }) esEdicion: boolean;
  @Prop({ required: true }) recibido: number;
  @Prop({ required: true }) receptor: string;
  @Prop({ required: true }) edited: any;
  @Prop({ required: true }) despachos: any;
  @Prop({ required: true }) estados: any;
  @Prop({ required: true }) usuarioActivo: any;
  validForm: boolean = true;
  accion!: any;
  ordesList2: any;
  step = 'general';

  anulado: boolean = false;
  textoConDespacho =
    "El estado será actualizado a 'RECIBIDO' con recepción en fecha actual y el receptor seleccionado";
  textoSinDespacho = "El estado será actualizado a 'RECIBIDO' ";

  rules = {
    required: (value: any) => {
      if (this.formFields.despacho.value != '') {
        return !!value || 'Required.';
      }
    },
  };

  getMovimiento() {
    this.formFields.usuario.value = this.edited.nombre;
    this.formFields.fechaAlta.value = moment(this.edited.movifecha_alta);
    this.formFields.movimiento.value = this.edited.movinumero;
    this.formFields.observacion.value = this.edited.moviobs;
    this.formFields.operacion.value = this.edited.operacion;
    this.formFields.destino.value = this.edited.destinoname;
    this.formFields.origen.value = this.edited.origen;
    this.formFields.estado.value = this.edited.moviestado;
    console.log('Recibido: ', this.recibido);
    console.log('Estado: ', this.edited.moviestado);
    this.formFields.despacho.value = this.edited.despanumero;
    this.formFields.fechaRecepcion.value =
      this.edited.movifecha_recibe == ' '
        ? this.edited.movifecha_recibe
        : moment();

    if (this.receptor == '') {
      this.formFields.receptor.value =
        this.formFields.despacho.value != '' &&
        this.edited.despareceptor == '' &&
        this.esEdicion
          ? this.usuarioActivo.nombre + ' ' + this.usuarioActivo.apellidopaterno
          : this.edited.despareceptor;
    } else {
      this.formFields.receptor.value = this.receptor;
    }

    this.$emit('receptor', this.formFields.receptor.value);
  }

  editar() {
    alert(this.formFields.receptor.value);
  }

  mounted() {
    this.getMovimiento();
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  formFields: {
    fechaAlta: any;
    movimiento: any;
    usuario: any;
    origen: any;
    operacion: any;
    observacion: any;
    destino: any;
    caja: any;
    despacho: any;
    estado: any;
    fechaRecepcion: any;
    receptor: any;
  } = {
    receptor: {
      label: 'Receptor en Despacho',
      value: '',
    },
    estado: {
      label: 'Estado (Obligatorio)',
      value: '',
    },
    despacho: {
      label: 'Número Orden Despacho',
      value: '',
    },
    caja: {
      label: 'Caja Número',
      value: '',
    },
    destino: {
      label: 'Destino',
      value: '',
    },
    observacion: {
      label: 'Observación',
      value: '',
    },
    fechaAlta: {
      label: 'Fecha Alta',
      value: moment(),
    },
    fechaRecepcion: {
      label: 'Fecha Recepción',
      value: moment(),
    },
    movimiento: {
      label: 'Movimiento',
      value: '',
    },
    usuario: {
      label: 'Usuario',
      value: '',
    },
    origen: {
      label: 'Origen',
      value: '',
    },
    operacion: {
      label: 'Operación',
      value: '5',
    },
  };

  //abstract
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.MovimientoDispositivos;

  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;

  //Interface
  estadoSwitch: boolean = false;

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  //@Watch('show')
  async onPropertyChanged(value: boolean) {
    this.dialog = value;
  }
}
